@let d = item();
@let list = d.list;
@if (list && list.length > 0) {
  <ng-template [ngTemplateOutlet]="listTpl" />
} @else {
  <div class="notice-icon__notfound">
    @if (d.emptyImage) {
      <img class="notice-icon__notfound-img" [attr.src]="d.emptyImage" alt="not found" />
    }
    <p>
      <ng-container *nzStringTemplateOutlet="d.emptyText">
        {{ d.emptyText || locale().emptyText }}
      </ng-container>
    </p>
  </div>
}
<ng-template #listTpl>
  <nz-list [nzDataSource]="list" [nzRenderItem]="item">
    <ng-template #item let-item>
      <nz-list-item (click)="onClick(item)" [class.notice-icon__item-read]="item.read">
        <nz-list-item-meta [nzTitle]="nzTitle" [nzDescription]="nzDescription" [nzAvatar]="item.avatar">
          <ng-template #nzTitle>
            <ng-container *nzStringTemplateOutlet="item.title; context: { $implicit: item }">
              {{ item.title }}
            </ng-container>
            @if (item.extra) {
              <div class="notice-icon__item-extra">
                <nz-tag [nzColor]="item.color">{{ item.extra }}</nz-tag>
              </div>
            }
          </ng-template>
          <ng-template #nzDescription>
            @if (item.description) {
              <div class="notice-icon__item-desc">
                <ng-container *nzStringTemplateOutlet="item.description; context: { $implicit: item }">
                  {{ item.description }}
                </ng-container>
              </div>
            }
            @if (item.datetime) {
              <div class="notice-icon__item-time">{{ item.datetime }}</div>
            }
          </ng-template>
        </nz-list-item-meta>
      </nz-list-item>
    </ng-template>
  </nz-list>
  <div class="notice-icon__clear" (click)="onClear()">{{ d.clearText || locale().clearText }}</div>
</ng-template>
